<template>
    <div>
        <item-detail-component :item-type="'openMarketDetail'" :item-key="itemKey"></item-detail-component>
        <auction-history-modal></auction-history-modal>
        <commission-info-modal></commission-info-modal>
        <share-modal></share-modal>
        <gift-item-modal></gift-item-modal>
    </div>
</template>

<script>
import HistoryListComponent from "@/components/history/HistoryListComponent";
import CommissionInfoModal from "@/components/modal/CommissionInfoModal";
import ItemDetailComponent from "@/components/item/ItemDetailComponent";
import ShareModal from "@/components/modal/ShareModal";
import AuctionHistoryModal from "@/components/modal/AuctionHistoryModal";
import GiftItemModal from "@/components/modal/GiftItemModal";

export default {
    name: "ItemDetail",
    mixins: [],
    components: {
        GiftItemModal,
        AuctionHistoryModal,
        ShareModal,
        ItemDetailComponent,
        CommissionInfoModal,
        HistoryListComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            itemKey: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.itemKey = this.$route.params.idx
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
